<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const emit = defineEmits(['optionClick']);

const { t } = useI18n();

// The same three actions, in the woot's order, in the shared kit DropdownMenu.
const menuItems = computed(() => [
  {
    action: 'mark_all_read',
    icon: 'i-lucide-mail-check',
    label: t('INBOX.MENU_ITEM.MARK_ALL_READ'),
  },
  {
    action: 'delete_all',
    icon: 'i-lucide-trash-2',
    label: t('INBOX.MENU_ITEM.DELETE_ALL'),
  },
  {
    action: 'delete_all_read',
    icon: 'i-lucide-trash',
    label: t('INBOX.MENU_ITEM.DELETE_ALL_READ'),
  },
]);

const onAction = ({ action }) => emit('optionClick', action);
</script>

<template>
  <DropdownMenu
    :menu-items="menuItems"
    class="z-50 min-w-40 max-w-64 w-max"
    @action="onAction"
    @click.stop
  />
</template>
